/*
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: dengyao
 * @LastEditTime: 2024-06-29 08:49:49
 */
/**名称和URL关联枚举 */
enum UnionEnum {
  /**首页 */
  HOME,
  /** 数据看板 */
  DATADASHBOARD,
  /**无权限 */
  NOAUTH,
  /**登录 */
  LOGIN,
  /** 忘记密码 */
  FORGETPWD,
  /**notFound */
  NOTFOUND,
  /** 审核拦截 */
  AUDITINTERCEPTION,
  /** 快件跟踪 */
  EXPRESSTRACKING,
  /** 订单录入 */
  ORDERENTRY,
  /** 客户管理 */
  CLIENTMANAGEMENT,
  /** 交接列表 */
  HANDOVERLIST,
  /** 交接详情 */
  HANDOVERDETAIL,
  /** 订单列表 */
  ORDERLIST,
  /** 寄件入库 */
  SENDWAREHOUSE,
  /** 修改密码 */
  UPDATEPWD,
  /** 打印设置 */
  PRINTSETTING,
  /** 寄件设置 */
  SENDSETTING,
  /**派件列表 */
  DISPATCHLIST,
  /**发送记录 */
  SENDRECORD,
  /** 员工派件列表 */
  STAFFDISPATCHLIST,
  // 退件查询
  RETURNWAREHOUSE,
  // 退件登记
  RETURNWAREHOUSEENTRY
}

/**name 枚举 */
enum NameEnum {
  欢迎页 = UnionEnum.HOME,
  首页 = UnionEnum.DATADASHBOARD,
  无权限 = UnionEnum.NOAUTH,
  登录 = UnionEnum.LOGIN,
  忘记密码 = UnionEnum.FORGETPWD,
  审核拦截 = UnionEnum.AUDITINTERCEPTION,
  订单录入 = UnionEnum.ORDERENTRY,
  快件跟踪 = UnionEnum.EXPRESSTRACKING,
  客户管理 = UnionEnum.CLIENTMANAGEMENT,
  交接列表 = UnionEnum.HANDOVERLIST,
  交接详情 = UnionEnum.HANDOVERDETAIL,
  寄件入库 = UnionEnum.SENDWAREHOUSE,
  订单列表 = UnionEnum.ORDERLIST,
  修改密码 = UnionEnum.UPDATEPWD,
  打印设置 = UnionEnum.PRINTSETTING,
  寄件设置 = UnionEnum.SENDSETTING,
  派件列表 = UnionEnum.DISPATCHLIST,
  发送记录 = UnionEnum.SENDRECORD,
  员工派件列表 = UnionEnum.STAFFDISPATCHLIST,
  退件查询 = UnionEnum.RETURNWAREHOUSE,
  退件登记 = UnionEnum.RETURNWAREHOUSEENTRY
}

/**Url 枚举 */
enum UrlEnum {
  '/' = UnionEnum.HOME,
  '/dataDashboard' = UnionEnum.DATADASHBOARD,
  '/noAuth' = UnionEnum.NOAUTH,
  '/login' = UnionEnum.LOGIN,
  '/forgetPwd' = UnionEnum.FORGETPWD,
  '/notFound' = UnionEnum.NOTFOUND,
  '/auditInterception' = UnionEnum.AUDITINTERCEPTION,
  '/expressTracking' = UnionEnum.EXPRESSTRACKING,
  '/OrderEntry' = UnionEnum.ORDERENTRY,
  '/clientManagement' = UnionEnum.CLIENTMANAGEMENT,
  '/handoverList' = UnionEnum.HANDOVERLIST,
  'handoverDetail' = UnionEnum.HANDOVERDETAIL,
  '/sendWarehouse' = UnionEnum.SENDWAREHOUSE,
  '/orderList' = UnionEnum.ORDERLIST,
  '/updatePwd' = UnionEnum.UPDATEPWD,
  '/printSetting' = UnionEnum.PRINTSETTING,
  '/sendSetting' = UnionEnum.SENDSETTING,
  '/dispatchList' = UnionEnum.DISPATCHLIST,
  '/sendRecord' = UnionEnum.SENDRECORD,
  '/staffDispatchList' = UnionEnum.STAFFDISPATCHLIST,
  '/returnWarehouse' = UnionEnum.RETURNWAREHOUSE,
  '/returnWarehouseEntry' = UnionEnum.RETURNWAREHOUSEENTRY
}
export { NameEnum, UrlEnum, UnionEnum }
